// Max characters of a stack trace we keep. Splunk chops oversized events, and a
// deep React stack can run to tens of kilobytes.
const MAX_STACK_LENGTH = 4000;

const truncate = (value) => (
    typeof value === 'string' && value.length > MAX_STACK_LENGTH
        ? `${value.slice(0, MAX_STACK_LENGTH)}…[truncated]`
        : value
);

export const normalizeException = (exception) => {
    // We stringify and parse it back to back, because the
    // stringify actually creates the object we are logging,
    // which is not a match for the exception itself.
    // Specifically fields do not exist on the exception,
    // but do exist on the stringified json.

    const replaceErrors = (_, value) => {
        // https://stackoverflow.com/a/18391400
        // We use this because error properties are
        // not enumerable, and JSON.stringify
        // will just return {} for a straight error
        if (value instanceof Error) {
            const error = {};

            Object.getOwnPropertyNames(value).forEach((name) => {
                error[name] = truncate(value[name]);
            });
            return error;
        }
        return value;
    };

    try {
        return JSON.parse(JSON.stringify(exception, replaceErrors));
    } catch (e) {
        // this can happen with a circular reference in the exception,
        // so just do our best
        try {
            if (exception && exception.stack && exception.message) {
                return {
                    message: exception.message,
                    stack: truncate(exception.stack)
                };
            }
        } catch (e2) {
            // A getter on the exception threw. Nothing left to salvage.
            return { serializationFailed: true };
        }
    }
    // if we got this far they passed us something that has a circular
    // reference, and was probably not an actual Error object
    return undefined;
};

export default normalizeException;
